"use client";

import { ProUpgradeLimitDialog } from "@/components/freemium/ProUpgradeLimitDialog";
import { useCurrentUser } from "@/hooks/queries/useCurrentUser";
import type { ProUpgradeLimitVariant } from "@/lib/plan-limit-ui";

type WorkspaceLimitKind = "notebook" | "note";

const KIND_TO_VARIANT: Record<WorkspaceLimitKind, ProUpgradeLimitVariant> = {
  notebook: "folders",
  note: "sections",
};

type Props = {
  open: boolean;
  kind: WorkspaceLimitKind | null;
  onOpenChange: (open: boolean) => void;
  onNavigateHome?: () => void;
};

/** @deprecated Prefer `ProUpgradeLimitDialog` + `useProUpgradeLimitDialog` in new code. */
export function WorkspaceLimitDialog({
  open,
  kind,
  onOpenChange,
  onNavigateHome: _onNavigateHome,
}: Props) {
  const variant = kind ? KIND_TO_VARIANT[kind] : null;
  const { data: user } = useCurrentUser();
  return (
    <ProUpgradeLimitDialog
      open={open}
      variant={variant}
      isPro={Boolean(user?.is_pro)}
      onOpenChange={onOpenChange}
    />
  );
}
